import GiftCardCategory from './screens/category'
import Occasions from './screens/occasions'
import Categories from './screens/categories'
import CartSummary from './screens/cart-summary'
import Success from './screens/success'
import GenericError from './screens/error/generic-error'
import TxnError from './screens/error/txn-error'
import PromotionError from './screens/error/promotion-error'
import Businesses from './screens/businesses'
import BusinessesSearch from './screens/businesses/BusinessesSearch'

import {
  Home,
  BundlesWithData,
  CardsWithData,
  Deals,
  SearchResults,
  CustomBundles,
  CustomBundlesCart,
} from './pages'
import clientData from './utils/client-data'
import PaymentError from './screens/error/payment-error'

const routes = [
  {
    path: '/',
    exact: true,
    component: Home,
    pgrp: 'main:consumer:gifts:home:::',
    enabled: true,
  },
  {
    path: '/all',
    exact: true,
    component: CardsWithData,
    pgrp: 'main:consumer:gifts:allcards:::',
    enabled: true,
  },
  {
    path: '/bundles',
    exact: true,
    component: BundlesWithData,
    pgrp: 'main:consumer:gifts:bundles:::',
    enabled: !!clientData.experimentation.v2bundles,
  },
  {
    path: '/byob',
    exact: true,
    component: CustomBundles,
    pgrp: 'main:consumer:gifts:bundles:byo::',
    enabled: !!clientData.experimentation.v2bundles,
  },
  {
    path: '/byob/add',
    exact: true,
    component: CustomBundlesCart,
    pgrp: 'main:consumer:gifts:bundles:byo:addtocart:',
    enabled: !!clientData.experimentation.v2bundles,
  },
  {
    path: '/deals',
    exact: true,
    component: Deals,
    pgrp: 'main:consumer:gifts:deals:::',
    enabled: true,
  },
  {
    path: '/deals/:dealsName',
    exact: true,
    component: Deals,
    pgrp: 'main:consumer:gifts:deals:::',
    enabled: true,
  },
  {
    path: '/occasions',
    exact: true,
    component: Occasions,
    enabled: !!clientData.experimentation.v2occasions,
  },
  {
    path: '/categories',
    exact: true,
    component: Categories,
    enabled: !!clientData.experimentation.categoriesTab,
  },
  {
    path: '/business/search',
    exact: true,
    component: BusinessesSearch,
    enabled: !!clientData.experimentation.localBusinesses,
  },
  {
    path: '/business',
    exact: true,
    component: Businesses,
    enabled: !!clientData.experimentation.localBusinesses,
  },
  {
    path: '/categories/:name',
    exact: true,
    component: GiftCardCategory,
    enabled: !!clientData.experimentation.categoriesTab,
  },
  {
    path: '/occasions/:name',
    exact: true,
    component: GiftCardCategory,
    enabled: !!clientData.experimentation.v2occasions,
  },
  {
    path: '/search/:type',
    exact: true,
    component: SearchResults,
    pgrp: 'main:consumer:gifts:search:::',
    enabled: true,
  },
  {
    path: '/search',
    exact: true,
    component: SearchResults,
    pgrp: 'main:consumer:gifts:search:::',
    enabled: true,
  },
  {
    path: '/cartsummary',
    exact: true,
    component: CartSummary,
    pgrp: 'main:consumer:gifts:cartsummary:::',
    enabled: true,
  },
  {
    path: '/success',
    exact: true,
    component: Success,
    pgrp: 'main:consumer:gifts:success:::',
    enabled: true,
  },
  {
    path: '/error',
    exact: true,
    component: GenericError,
    pgrp: 'main:consumer:gifts:error:::',
    enabled: true,
  },
  {
    path: '/txnerror',
    exact: true,
    component: TxnError,
    pgrp: 'main:consumer:gifts:txnerror:::',
    enabled: true,
  },
  {
    path: '/promotionerror',
    exact: true,
    component: PromotionError,
    pgrp: 'main:consumer:gifts:promotionerror:::',
    enabled: true,
  },
  {
    path: '/paymenterror',
    exact: true,
    component: PaymentError,
    pgrp: 'main:consumer:gifts:paymenterror:::',
    enabled: true,
  },
]

export default routes
